export const DataOnline = {
  howTo: {
    title: "Caranya Gampang!",
    subtitle:
      "Pengen tahu bagaimana mendapatkan barang kesukaan Kamu secara cepat? Yuk lihat petunjuk pembelian sekarang!",
    steps: [
      "Pilih produk yang kamu mau di e-commerce pilihan kamu",
      "Pilih Home Credit Indonesia sebagai pilihan pembayaran dan ikuti petunjuk untuk mengisi form aplikasi",
      "Tunggu pemberitahuan persetujuan kredit kamu sekitar 30 menit",
      "Ikuti petunjuk selanjutnya untuk mengkonfirmasi kontrak kamu",
      "Barang impian kamu langsung siap dikirim."
    ]
  },
  tnc: {
    title: "Kamu bisa dapatkan barang impian dengan Home Credit, jika kamu:",
    steps: [
      "<p>Warga Negara Indonesia dan memiliki KTP</p>",
      "<p>Berumur minimum 21 tahun atau 19 tahun (bila sudah menikah)</p>",
      "<p>Bertempat tinggal di area layanan kami</p>",
      "<p>Memiliki penghasilan tetap</p>"
    ]
  }
};

export const DataOffline = {
  howTo: {
    title: "Caranya Gampang!",
    steps: [
      "Siapkan KTP dan 1 Dokumen Pendukung lainnya",
      "Kunjungi Toko Mitra terdekat dan pilih barang dan rencana pembiayaan yang kamu mau",
      "Sales Associate kami akan memproses aplikasi kamu dalam waktu kurang lebih 3 menit",
      "Baca dan tandatangan kontrak, serta bayar Biaya DP dan Admin",
      "Bawa pulang barang impian kamu."
    ]
  },
  tnc: {
    title: "Kamu bisa dapatkan barang impian dengan Home Credit, jika kamu:",
    steps: [
      "<p>Warga Negara Indonesia dan memiliki KTP</p>",
      "<p>Berumur minimum 21 tahun atau 19 tahun (bila sudah menikah)</p>",
      "<p>Bertempat tinggal di area layanan kami</p>",
      "<p>Memiliki penghasilan tetap</p>"
    ]
  }
};
export const DataHomeCreditApp = {
  download: {
    title: "Download Sekarang!",
    desc:
      "Mau bayar cicilan, atur jadwal pembayaran, sampai dapet reward tiap bulan dari satu aplikasi? Download My Home Credit sekarang dan dapetin keseruannya!"
  },
  stepsDownload: {
    title: "Mulai Keseruannya!",
    steps: [
      "Download aplikasi My Home Credit",
      `Masukkan Data:
      <br/>&bull;  <span style="color: #404040;">Tanggal lahir sesuai KTP</span>
      <br/>&bull; <span style="color: #404040;">Nomor handphone aktif</span>
      <br/>&bull; <span style="color: #404040;">PIN</span>`,
      "Tulis Kode Verifikasi yang akan dikirim ke nomor kamu"
    ]
  },
  benefitApp: {
    title: "Nikmati Banyak Kejutannya!",
    steps: [
      "Bayar cicilan langsung lewat App",
      "Cek status pengajuan dan kontrak",
      "Dapatkan reward dan promo",
      "Ikut mission dan kuis seru!",
      "Dan banyak lainnya!"
    ]
  }
};
export const DataTwoWheelers = {
  howTo: {
    title: "Caranya Gampang!",
    subtitle:
      "Karena dengan pilih Home Credit, kamu akan menikmati santainya prosedur, di mana kamu cukup:",
    steps: [
      "Membawa KTP dan KK asli",
      "Tunggu persetujuan sekitar 30 menit",
      "Voila! Motor impianmu akan segera diantar jika pengajuan pembiayaanmu disetujui.",
      "Lalu? Tunggu apa lagi? Gaspol motor impian dengan pilih cara yang #GakRibetLagi! "
    ]
  }
};
export const DataSyaratKetentuanTwoWheelers = {
  howTo: {
    title: "Syarat & Ketentuan",
    steps: [
      "Warga Negara Indonesia berusia minimal 21 tahun (atau 19 tahun jika sudah menikah) hingga maksimal 55 tahun",
      "Memiliki KTP yang masih berlaku, atau e-KTP dengan masa berlaku seumur hidup. Pengajuan tidak dapat dilakukan dengan resi KTP, dan akan dibatalkan secara otomatis",
      "Memiliki Kartu Keluarga yang berlaku sebagai salah satu dokumen pendukung untuk pengajuan aplikasi Pembiayaan Kendaraan Roda Dua",
      "Memiliki pekerjaan dengan penghasilan tetap",
      "Bertempat tinggal di area layanan Home Credit Indonesia",
      "Maksimum harga kendaraan roda dua yang dibiayai mencapai Rp50 juta dengan jangka waktu cicilan selama 11 hingga 35 bulan",
      "Mengajukan cicilan di salah satu dari 38 dealer Yamaha Putra di kawasan Jabodetabek yang akan dibuka secara bertahap",
      "Membawa KTP dan Kartu Keluarga asli",
      "Mengisi formulir aplikasi dari Sales Associate Home Credit"
    ]
  }
};
